'use client';

import {
	Accordion,
	Box,
	For,
	Stack,
	Text,
} from '@chakra-ui/react';
import { useLocale } from 'next-intl';

import { CustomPortableText } from '@/modules/sanity-studio/components';
import type { FaqPage } from '@/modules/sanity-studio/types';
import { FAQAccordion } from '../../components';
import React from 'react';
import { DefaultStyle } from '@packages/wastic-shared';

type FAQCategoryProps = {
	faqPage: FaqPage;
};

const FAQContainer = ({ faqPage }: FAQCategoryProps) => {
	const locale = useLocale() as 'en' | 'th';

	return (
		<Stack gap={DefaultStyle.CONTENT_GAP}>
			<Stack alignItems={'center'} gap={DefaultStyle.NO_GAP}>
				<Text as={'h2'} textAlign={'center'} textStyle={'h2'}>{faqPage.title[locale]}</Text>
				<Box maxW={'80ch'} px={8} textAlign={'center'}>
					<CustomPortableText value={faqPage.description[locale] as never} />
				</Box>
			</Stack>
			<For each={faqPage.categories} >
				{category => (
					<Stack key={category.title[locale]} gap={DefaultStyle.SMALL_SECTION_GAP}>
						<Text as={'h3'} textAlign={'center'} textStyle={'h3'}>{category.title[locale]}</Text>
						<Stack key={category.title[locale]} gap={DefaultStyle.TIGHT_SECTION_GAP}>
							<For each={category.faqs}>
								{({ answer, question }, index) => (
									<Accordion.Root
										key={`${question[locale]} + ${index}`}
										multiple
										bg={'white'}
										borderRadius={'md'}
										shadow={'md'}
										size={'lg'}
										variant={'enclosed'}
									>
										<FAQAccordion
											answer={answer[locale] as never}
											id={`${question[locale]} + ${index}`}
											question={question[locale] ?? ''}
										/>
									</Accordion.Root>
								)}
							</For>
						</Stack>
					</Stack>
				)}
			</For>
		</Stack>
	);
};

export default FAQContainer;